import { createAsyncThunk } from '@reduxjs/toolkit';
import axiosInstance from 'utils/axios';

export const getAllBanner = createAsyncThunk('banner/getAllBanner', async (_, thunkAPI) => {
  try {
    const response = await axiosInstance.get(`/admin/banner`);

    return response.data;
  } catch (error) {
    return thunkAPI.rejectWithValue(error.response?.data?.data?.message || error.message);
  }
});

export const getDetailBanner = createAsyncThunk('banner/getDetailBanner', async (id, thunkAPI) => {
  try {
    const response = await axiosInstance.get(`/banner/${id}`);

    return response.data;
  } catch (error) {
    return thunkAPI.rejectWithValue(error.response?.data?.data?.message || error.message);
  }
});

export const updateBanner = createAsyncThunk('banner/updateBanner', async (payload, thunkAPI) => {
  const { id, data } = payload;
  try {
    const response = await axiosInstance.put(`/banner/${id}`, data);

    return response.data;
  } catch (error) {
    return thunkAPI.rejectWithValue(error.response?.data?.data?.message || error.message);
  }
});

export const createBanner = createAsyncThunk('banner/createBanner', async ({ data }, thunkAPI) => {
  const { sort, ...rest } = data;

  const payload = {
    ...rest,
    sort: sort > 0 ? sort : undefined,
  };

  try {
    await axiosInstance.post(`/banner`, { ...payload });
    thunkAPI.dispatch(getAllBanner());
  } catch (error) {
    return thunkAPI.rejectWithValue(error.response?.data?.data?.message || error.message);
  }
});

export const uploadBannerImage = createAsyncThunk('banner/uploadBanner', async ({ payload, data }, thunkAPI) => {
  try {
    const response = await axiosInstance.post(`/banner/upload`, payload, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
    const uploadedImageString = response.data?.file;
    if (!uploadedImageString) return thunkAPI.rejectWithValue('Gagal Upload Image');

    thunkAPI.dispatch(createBanner({ data: { ...data, image: uploadedImageString } }));
  } catch (error) {
    return thunkAPI.rejectWithValue(error.response?.data?.data?.message || error.message);
  }
});

export const deleteBanner = createAsyncThunk('banner/deleteBanner', async (id, thunkAPI) => {
  try {
    await axiosInstance.delete(`/banner/${id}`);
  } catch (error) {
    return thunkAPI.rejectWithValue(error.response?.data?.data?.message || error.message);
  }
});
